module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_4.f75764dc.jpg";